import React, { useState } from 'react';
import { ImageGalleryProps } from './image-gallery.types';
import { getContainerSize } from './image-gallery.utils';
import { ImageView } from './image-view/image-view';
import { GallerySlider } from './gallery-slider/gallery-slider';

const THUMBNAIL_WIDTH = 75;
const THUMBNAIL_MARGIN = 25;

const ImageGalleryComponent = (props: ImageGalleryProps) => {
  const {
    images,
    maxContainerWidth = 355,
    maxContainerHeight = 507,
  } = props;

  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div
      style={getContainerSize(maxContainerWidth, maxContainerHeight)}
    >
      <ImageView
        image={images[currentIndex]}
        width={maxContainerWidth}
      />

      <GallerySlider
        objects={images.map((image, index) => ({
          image,
          onClick: () => setCurrentIndex(index)
        }))}
        thumbnailWidth={THUMBNAIL_WIDTH}
        thumbnailMargin={THUMBNAIL_MARGIN}
        maxContainerWidth={maxContainerWidth}
      />

    </div>
  );
};

const ImageGallery = ImageGalleryComponent;
export { ImageGallery };
